import { BoxProps } from "@mui/material";
import { IndexCompareItem } from "./ChartIndexCompare";
import { isDefined } from "@app/utils";
import { CarExcelTable } from "./ExcelTable";
import { ExcelDataFormat, ExcelTable } from "@app/hooks/useExcelExport";

interface TableIndexCompareProps {
  sx?: BoxProps["sx"];
  item1?: IndexCompareItem;
  item2?: IndexCompareItem;
  item3?: IndexCompareItem;
  isWhiteContext: boolean;
}

export const getIndexCompareTable = ({
  item1,
  item2,
  item3,
}: {
  item1?: IndexCompareItem;
  item2?: IndexCompareItem;
  item3?: IndexCompareItem;
}): ExcelTable => {
  const items = [item1, item2, item3].filter(isDefined);

  return {
    name: "Index Compare",
    columns: [
      {
        label: "",
        format: ExcelDataFormat.general,
      },
      ...items.map((i) => ({
        label: i.name,
        format: ExcelDataFormat.percent,
      })),
    ],
    rows: [
      [
        "Price-Driven Expected Return",
        ...items.map((i) => i.priceDrivenExpectedReturn),
      ],
      ["Volatility", ...items.map((i) => i.volatility)],
      // [
      //   "Expected Trend Return",
      //   ...items.map((i) => i.regressionModelDetailData?.beta),
      // ],
    ],
  };
};

export const TableIndexCompare = ({
  sx,
  item1,
  item2,
  item3,
  isWhiteContext,
}: TableIndexCompareProps) => {
  const table = getIndexCompareTable({ item1, item2, item3 });

  return <CarExcelTable sx={sx} table={table} />;
};
